import { render, staticRenderFns } from "./AfterDeliveryPopup.vue?vue&type=template&id=6be56718&"
import script from "./AfterDeliveryPopup.vue?vue&type=script&lang=js&"
export * from "./AfterDeliveryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports